// TODO: Delete remaining wizard hooks once home page is migrated to academy-home-ui
import { useUserAttribute } from '../../userAttributes/userAttributesQueries.migrated';
import { UserAttributeKeys } from '../../userAttributes';
export const useSavedLearningInterest = () => {
  const {
    userAttributeLoading: isLoadingLearningInterest,
    userAttribute: wizardResults,
    userAttributesError: learningInterestError
  } = useUserAttribute(UserAttributeKeys.WIZARD_RESULTS);
  const savedState = {
    resultCount: 0,
    isToolsSelected: false,
    showOnlyCerts: false,
    isLoadingLearningInterest,
    hasLearningInterest: !!wizardResults,
    learningInterestError
  };
  if (wizardResults) {
    return Object.assign({}, savedState, {
      selectedTool: wizardResults.selectedTool,
      isToolsSelected: wizardResults.isToolsSelected,
      selectedToolsGroup: wizardResults.selectedToolsGroup,
      selectedCategoryGroup: wizardResults.selectedCatGroup,
      selectedCategory: wizardResults.selectedCat,
      showOnlyCerts: wizardResults.selectedShowCertificatesOnly,
      resultCount: wizardResults.resultCount
    });
  }
  return savedState;
};